import React from 'react';
import { Box, Text, TextExtendedProps } from '@common-fe/common-fe';

interface Props extends TextExtendedProps {
  testId: string;
  children: React.ReactNode;
  isNodeMode?: boolean;
  title: string;
}

const EnrollmentInvestmentsItem: React.FC<Props> = ({ testId, children, title, isNodeMode, ...rest }) => {
  if (!children) {
    return null;
  }
  return (
    <Box
      direction="row"
      height={{ min: '24px' }}
      align="center"
      data-testId={`${testId}_field-wrapper`}
      justify="between"
      style={{ flex: 1 }}
    >
      <Text size="medium" data-testId={`${testId}_title`} weight={700}>
        {title}
      </Text>
      {isNodeMode ? (
        children
      ) : (
        <Text size="medium" data-testId={`${testId}_value`} weight={400} {...rest}>
          {children}
        </Text>
      )}
    </Box>
  );
};
export default EnrollmentInvestmentsItem;
